import { useState } from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import logo from '../assets/logo.webp'
import {
  countries,
  majorOptions,
  degreeOptions,
  institutionOptions,
  issuingStateOptions,
  typeOfDegreeOptions,
} from '../assets/data'
import { db, storage } from '../firebase/setup'
import { collection, addDoc } from 'firebase/firestore'
import { ref, uploadBytes } from 'firebase/storage'
import { v4 } from 'uuid'

const Wrapper = styled.div`
  text-align: center;
  padding: 2em 0;
`

const SuccessWrapper = styled.div`
  margin-top: 2em;

  h1 {
    text-align: center !important;
  }
`

const Image = styled.img``

const Overlay = styled.div`
  background: rgb(54, 52, 48);
  border-radius: 8px;
  padding: 2em;
  text-align: left;
`

const Info = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-top: 2em;
  margin-bottom: 1em;
`

const BigTitle = styled.span`
  font-size: 36px;
  font-weight: 600;
`

const StepInfo = styled.span`
  font-size: 18px;
  font-weight: 400;
`

const Input = styled.input`
  width: 100%;
  background: transparent;
  border: 2px solid #fff;
  padding: 0.2em 0.5em;
  color: #fff;
  height: 35px;
  transition: 0.2s ease-in-out;
  margin-top: 4px;

  &:hover,
  &:focus {
    border-color: rgb(219, 179, 99);
  }
`
const Select = styled.select`
  width: 100%;
  background: transparent;
  border: 2px solid #fff;
  margin-top: 4px;
  color: #fff;
  height: 35px;
  padding: 0.2em 0.5em;
`
const TextArea = styled.textarea`
  display: block;
  background: transparent;
  border: 2px solid #fff;
  padding: 0.2em 0.5em;
  color: #fff;
  width: 100%;
  resize: none;
  height: 70px;
  margin-top: ${(props) => (props.margin ? '12px' : '4px')};

  transition: 0.2s ease-in-out;

  &:hover,
  &:focus {
    border-color: rgb(219, 179, 99);
  }
`

const Title = styled.h1`
  font-size: 26px;
  font-weight: 600;
  text-align: left;
`

const Upload = styled.label`
  background: rgb(219, 179, 99);
  border-radius: 10px;
  padding: 0.5em 1.5em;
  cursor: pointer;
  width: 300px;
  text-align: center;
  transition: 0.2s ease-in-out;
  margin-top: 16px;

  &:hover {
    opacity: 0.85;
  }
`

const Button = styled.button`
  background: rgb(219, 179, 99);
  border-radius: 10px;
  padding: 0.5em 1.5em;
  cursor: pointer;
  border: none;
  color: #fff;
  width: 300px;
  transition: 0.2s ease-in-out;
  margin-top: 16px;

  &:hover {
    opacity: 0.85;
  }
`

const VerticalCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 300px;
`

const QA = styled.div``

const Question = styled.span`
  display: block;
  margin-top: ${(props) => (props.noMargin ? '0' : '22px')};
`

const Answer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 12px;
`

const Radio = styled.input`
  margin: 0 12px;
`

const RadioLabel = styled.span``

const InputLabel = styled.span`
  font-size: 16px;
  display: block;
  margin-top: 16px;
`

const Option = styled.option`
  color: black;
`

const Text = styled.p`
  font-size: 16px;
  display: block;
  font-weight: 500;
  margin-top: 12px;
`

const Checkbox = styled.input`
  margin: 0 12px;
`

const Divider = styled.span`
  font-weight: 500;
  font-size: 22px;
  line-height: 35px;
  padding: 0 1em;
`

const DatePickerWrapper = styled.span`
  width: 100%;
`

const DeleteInput = styled.span`
  text-align: right;
  width: 100%;
  display: inline-block;
  margin-top: 12px;
  cursor: pointer;
  color: rgb(219, 179, 99);
  font-weight: 500;
`

const HorizontalDivider = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  margin: 12px 0;
`

const AddInput = styled.span`
  cursor: pointer;
  color: rgb(219, 179, 99);
  font-weight: 500;
`

const Buttons = styled.div`
  margin-top: 1em;
  width: 100%;
  text-align: right;
`

const ButtonNav = styled.button`
  background: ${(props) => (props.back ? 'transparent' : 'rgb(219, 179, 99)')};
  border: ${(props) => (props.back ? '2px solid rgb(219, 179, 99)' : 'none')};
  border-radius: 10px;
  padding: 0.5em 1.5em;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
  margin-right: ${(props) => (props.back ? '1em' : '0')};

  &:hover {
    opacity: ${(props) => (props.back ? '1' : '0.85')};
    color: ${(props) => (props.back ? 'rgb(219, 179, 99)' : '#fff')};
  }
`

const Cancel = styled.span`
  cursor: pointer;
  color: #ef233c;
  font-weight: 500;
  margin-top: 12px;
  display: inline-block;
`

const Error = styled.div`
  transition: opacity 0.5s ease-in-out;
  background: rgb(54, 52, 48);
  position: fixed;
  top: 12px;
  left: calc(50% - 225px);
  padding: 1em;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  font-size: 18px;
  font-weight: 400;
  width: 450px;
  text-align: center;
  opacity: ${(props) => (props.isError ? '1' : '0')};
  pointer-events: none;
`

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1em;
`

const Italic = styled.span`
  font-style: italic;
`

const Home = () => {
  const [currentStep, setCurrentStep] = useState(1)
  const [typeCover, setTypeCover] = useState(false)
  const [isAgreed, setIsAgreed] = useState(false)
  const [isError, setIsError] = useState(false)
  const [message, setMessage] = useState(null)
  const [isSubmitted, setIsSubmitted] = useState(false)
  // form data
  const [inputs, setInputs] = useState({})
  const [experience, setExperience] = useState([])
  const [education, setEducation] = useState([])
  const [license, setLicense] = useState([])
  // files
  const [resumeAndOther, setResumeAndOther] = useState(null)
  const [coverLetter, setCoverLetter] = useState(null)
  const [additionalDocument, setAdditionalDocument] = useState(null)

  const handleInputs = (e) => {
    setInputs((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleExperienceInputs = (e, i) => {
    setExperience((prev) => {
      const _ = prev
      _[i] = {
        ..._[i],
        [e.target.name]:
          e.target.type === 'checkbox' ? e.target.checked : e.target.value,
      }
      return [..._]
    })
  }

  const handleEducationInputs = (e, i) => {
    setEducation((prev) => {
      const _ = prev
      _[i] = {
        ..._[i],
        [e.target.name]:
          e.target.type === 'checkbox' ? e.target.checked : e.target.value,
      }
      return [..._]
    })
  }

  const handleLicenseInputs = (e, i) => {
    setLicense((prev) => {
      const _ = prev
      _[i] = {
        ..._[i],
        [e.target.name]: e.target.value,
      }
      return [..._]
    })
  }

  const handleResumeAndOtherUploads = (e) => {
    setResumeAndOther(e.target.files)
  }

  const handleCoverLetterUpload = (e) => {
    setCoverLetter(e.target.files[0])
  }

  const handleAdditionalDocumentUpload = (e) => {
    setAdditionalDocument(e.target.files[0])
  }

  const showError = (message, duration = 3000) => {
    setMessage(message)
    setIsError(true)

    setTimeout(() => {
      setIsError(false)
    }, duration)
  }

  const nextStep = () => {
    const missingFields = []

    if (!inputs.firstName || inputs.firstName.length < 1) {
      missingFields.push('First Name')
    }

    if (!inputs.lastName || inputs.lastName.length < 1) {
      missingFields.push('Last Name')
    }

    if (!inputs.email || inputs.email.length < 1) {
      missingFields.push('Email')
    }

    if (resumeAndOther === null) {
      missingFields.push('Resume and Other Documents')
    }

    if (!inputs.phone || inputs.phone.length < 1) {
      missingFields.push('Phone')
    }

    if (!inputs.referralSource) {
      missingFields.push('Referral Source')
    }

    if (
      inputs.referralSource === 'Other' &&
      (!inputs.otherReferralSource || inputs.otherReferralSource.length < 1)
    ) {
      missingFields.push('Other Referral Source')
    }

    if (!inputs.position || inputs.position.length < 1) {
      missingFields.push('Position')
    }

    if (!inputs.relocate) {
      missingFields.push('Willingness to Relocate')
    }

    if (!inputs.workInUS) {
      missingFields.push('Work Authorization in the United States')
    }

    if (!inputs.alreadyEmployed) {
      missingFields.push('Previous Employment with Con-Real')
    }

    if (!inputs.sponsorship) {
      missingFields.push('Visa Sponsorship Requirement')
    }

    if (!inputs.crime) {
      missingFields.push('Criminal History Declaration')
    }

    const pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
    if (!pattern.test(inputs.email)) {
      showError('Email address is not valid.', 6000)
      return
    }

    if (experience.length > 0) {
      experience.forEach((exp, index) => {
        if (!exp.company || exp.company.length < 1) {
          missingFields.push(`Experience ${index + 1} - Company`)
        }
        if (!exp.position || exp.position.length < 1) {
          missingFields.push(`Experience ${index + 1} - Position`)
        }
        if (!exp.startDate || exp.startDate.length < 1) {
          missingFields.push(`Experience ${index + 1} - Start Date`)
        }
      })
    }

    if (education.length > 0) {
      education.forEach((edu, index) => {
        if (!edu.institution || edu.institution.length < 1) {
          missingFields.push(`Education ${index + 1} - Institution`)
        }
        if (!edu.typeOfDegree || edu.typeOfDegree.length < 1) {
          missingFields.push(`Education ${index + 1} - Type of Degree`)
        }
        if (!edu.degree || edu.degree.length < 1) {
          missingFields.push(`Education ${index + 1} - Degree`)
        }
        if (!edu.major || edu.major.length < 1) {
          missingFields.push(`Education ${index + 1} - Major`)
        }
      })
    }

    if (license.length > 0) {
      license.forEach((lic, index) => {
        if (!lic.professionalLicense || lic.professionalLicense.length < 1) {
          missingFields.push(`Professional License ${index + 1} - License Name`)
        }
      })
    }

    if (missingFields.length > 0) {
      showError(
        `Please fill in the following required fields: ${missingFields.join(
          ', ',
        )}`,
        6000,
      )
      return
    }

    setCurrentStep((prev) => prev + 1)
  }

  const handleSubmit = async () => {
    if (!isAgreed) {
      showError('You must agree with our acknowledgement.', 6000)
      return
    }

    if (isSubmitted) {
      showError('We will get back to you soon!')
      return
    }

    const id = v4()

    const docRef = await addDoc(collection(db, 'applicants'), {
      id,
      ...inputs,
      experience,
      license,
      education,
      date: Date.now(),
    })

    if (resumeAndOther !== null) {
      Array.from(resumeAndOther).forEach(async (doc) => {
        const docRef = ref(
          storage,
          `${id}/resume-and-other-documents/${doc.name}`,
        )
        await uploadBytes(docRef, doc)
      })
    }

    if (coverLetter !== null && typeCover !== true) {
      const coverLetterRef = ref(
        storage,
        `${id}/cover-letter/${coverLetter.name}`,
      )
      await uploadBytes(coverLetterRef, coverLetter)
    }

    if (additionalDocument !== null) {
      const additionalDocumentRef = ref(
        storage,
        `${id}/additional-document/${additionalDocument.name}`,
      )
      await uploadBytes(additionalDocumentRef, additionalDocument)
    }

    setIsSubmitted(true)
  }

  return (
    <Container>
      <Error isError={isError}>{message}</Error>
      <Wrapper>
        <a href='https://www.con-real.com'>
          <Image src={logo} alt='Con-Real' />
        </a>

        {isSubmitted ? (
          <SuccessWrapper>
            <Title>Thank you for your application.</Title>
            <Text>
              Our team will review your submission and contact you if your
              qualifications match our needs.
            </Text>
          </SuccessWrapper>
        ) : (
          <>
            <Info>
              <BigTitle>Apply</BigTitle>
              <StepInfo>Step {currentStep} of 2</StepInfo>
            </Info>
            <Overlay>
              {currentStep === 1 ? (
                <>
                  <Row className='section-row'>
                    <Title>Contact Information</Title>
                    <Col md={12} lg={6}>
                      <InputLabel>First name *</InputLabel>
                      <Input
                        name='firstName'
                        value={inputs.firstName}
                        onChange={handleInputs}
                      />
                    </Col>
                    <Col md={12} lg={6}>
                      <InputLabel>Last name *</InputLabel>
                      <Input
                        name='lastName'
                        value={inputs.lastName}
                        onChange={handleInputs}
                      />
                    </Col>
                    <Col md={12} lg={6}>
                      <InputLabel>Email *</InputLabel>
                      <Input
                        type='email'
                        name='email'
                        value={inputs.email}
                        onChange={handleInputs}
                      />
                    </Col>
                  </Row>

                  <Row className='section-row'>
                    <BigTitle>Con-Real</BigTitle>
                    <Text>
                      Our mission is “By delivering client-centric solutions,
                      innovating through diversity, and leading the future,{' '}
                      <Italic>the movement continues...</Italic>” <br /> <br />
                      Thank you for your interest in Con-Real.
                    </Text>
                  </Row>

                  <Row className='section-row'>
                    <Title>Upload Resume and Other Attachments *</Title>
                    <Col md={12} lg={6}>
                      <Upload htmlFor='cv'>Upload Resume/CV</Upload>
                      <Input
                        className='hidden'
                        type='file'
                        id='cv'
                        multiple
                        onChange={handleResumeAndOtherUploads}
                      />
                    </Col>
                  </Row>

                  <Row className='section-row'>
                    <Title>Contact Details</Title>
                    <Col md={12} lg={6}>
                      <InputLabel>Address Line 1</InputLabel>
                      <Input
                        name='addressLineOne'
                        value={inputs.addressLineOne}
                        onChange={handleInputs}
                      />
                    </Col>
                    <Col md={12} lg={6}>
                      <InputLabel>Address Line 2</InputLabel>
                      <Input
                        name='addressLineTwo'
                        value={inputs.addressLineTwo}
                        onChange={handleInputs}
                      />
                    </Col>
                    <Col md={12} lg={6}>
                      <InputLabel>City</InputLabel>
                      <Input
                        name='city'
                        value={inputs.city}
                        onChange={handleInputs}
                      />
                    </Col>
                    <Col md={12} lg={6}>
                      <InputLabel>State</InputLabel>
                      <Input
                        name='state'
                        value={inputs.state}
                        onChange={handleInputs}
                      />
                    </Col>
                    <Col md={12} lg={6}>
                      <InputLabel>Country</InputLabel>
                      <Select name='country' onChange={handleInputs}>
                        <Option value='' disabled selected>
                          Click to Select
                        </Option>
                        {countries.map((country) => (
                          <Option value={country}>{country}</Option>
                        ))}
                      </Select>
                    </Col>
                    <Col md={12} lg={6}>
                      <InputLabel>Zip Code</InputLabel>
                      <Input
                        name='zipCode'
                        value={inputs.zipCode}
                        onChange={handleInputs}
                      />
                    </Col>
                    <Col md={12} lg={6}>
                      <InputLabel>Phone *</InputLabel>
                      <Input
                        name='phone'
                        value={inputs.phone}
                        onChange={handleInputs}
                      />
                    </Col>
                  </Row>

                  <Row className='section-row'>
                    <Title>Prior Experience</Title>
                    {experience.length > 0 &&
                      experience.map((x, i) => (
                        <>
                          <Col md={12} lg={6}>
                            <InputLabel>Company *</InputLabel>
                            <Input
                              name='company'
                              value={experience[i].company}
                              onChange={(e) => handleExperienceInputs(e, i)}
                            />
                          </Col>
                          <Col md={12} lg={6}>
                            <InputLabel>Position *</InputLabel>
                            <Input
                              name='position'
                              value={experience[i].position}
                              onChange={(e) => handleExperienceInputs(e, i)}
                            />
                          </Col>
                          <Col md={12} lg={6} className='horizontal-flex'>
                            <DatePickerWrapper>
                              <InputLabel>Start Date *</InputLabel>
                              <DatePicker
                                format='MM/dd/yyyy'
                                value={experience[i].startDate}
                                selected={experience[i].startDate}
                                className='datepicker'
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode='select'
                                onChange={(date) =>
                                  setExperience((prev) => {
                                    const _ = prev
                                    _[i].startDate = date
                                    return [..._]
                                  })
                                }
                              />
                            </DatePickerWrapper>

                            <Divider>-</Divider>
                            <DatePickerWrapper>
                              <InputLabel>End Date</InputLabel>
                              <DatePicker
                                format='MM/dd/yyyy'
                                value={experience[i].endDate}
                                selected={experience[i].endDate}
                                showMonthDropdown
                                dropdownMode='select'
                                showYearDropdown
                                className='datepicker'
                                onChange={(date) =>
                                  setExperience((prev) => {
                                    const _ = prev
                                    _[i].endDate = date
                                    return [..._]
                                  })
                                }
                              />
                            </DatePickerWrapper>
                          </Col>
                          <Col md={12} lg={6}>
                            <InputLabel>Ending Salary</InputLabel>
                            <Input
                              name='endingSalary'
                              value={experience[i].endingSalary}
                              onChange={(e) => handleExperienceInputs(e, i)}
                            />
                          </Col>
                          <Col md={12} lg={12}>
                            <CheckboxWrapper>
                              <Answer>
                                <Checkbox
                                  type='checkbox'
                                  id='currentEmployeer'
                                  name='currentEmployer'
                                  value={experience[i].currentEmployer}
                                  onChange={(e) => handleExperienceInputs(e, i)}
                                />
                                <RadioLabel htmlFor='currentEmployeer'>
                                  Current Employer?
                                </RadioLabel>
                              </Answer>
                              <Answer>
                                <Checkbox
                                  type='checkbox'
                                  id='contactEmployer'
                                  name='contactEmployer'
                                  value={experience[i].contactEmployer}
                                  onChange={(e) => handleExperienceInputs(e, i)}
                                />
                                <RadioLabel htmlFor='contactEmployer'>
                                  May We Contact?
                                </RadioLabel>
                              </Answer>
                            </CheckboxWrapper>
                          </Col>
                          <Col md={12} lg={12}>
                            <InputLabel>
                              What did you like about this position?
                            </InputLabel>
                            <TextArea
                              name='details'
                              value={experience[i].details}
                              onChange={(e) => handleExperienceInputs(e, i)}
                            ></TextArea>
                          </Col>
                          <Col md={12} lg={12}>
                            <InputLabel>Reason For Leaving</InputLabel>
                            <TextArea
                              name='reasonForLeaving'
                              value={experience[i].reasonForLeaving}
                              onChange={(e) => handleExperienceInputs(e, i)}
                            ></TextArea>
                            <DeleteInput
                              onClick={() =>
                                setExperience((prev) => {
                                  const array = [...prev]
                                  array.splice(i, 1)
                                  return [...array]
                                })
                              }
                            >
                              Delete Experience
                            </DeleteInput>
                            <HorizontalDivider></HorizontalDivider>
                          </Col>
                        </>
                      ))}

                    <AddInput
                      onClick={() =>
                        setExperience((prev) => [
                          ...prev,
                          {
                            company: '',
                            position: '',
                            startDate: '',
                            endDate: '',
                            currentEmployer: false,
                            contactEmployer: false,
                            endingSalary: '',
                            details: '',
                            reasonForLeaving: '',
                          },
                        ])
                      }
                    >
                      Add Prior Experience
                    </AddInput>
                  </Row>

                  <Row className='section-row'>
                    <Title>Applicant Education</Title>
                    {education.length > 0 &&
                      education.map((x, i) => (
                        <>
                          <Col md={12} lg={6}>
                            <InputLabel>Institution *</InputLabel>
                            <Input
                              onChange={(e) => handleEducationInputs(e, i)}
                              name='institution'
                              value={education[i].institution}
                            />
                          </Col>
                          <Col md={12} lg={6}>
                            <InputLabel>Type of Degree *</InputLabel>
                            <Select
                              name='typeOfDegree'
                              value={education[i].typeOfDegree}
                              onChange={(e) => handleEducationInputs(e, i)}
                            >
                              <Option value='' disabled selected>
                                Click to Select
                              </Option>
                              {typeOfDegreeOptions.map((x) => (
                                <Option value={x}>{x}</Option>
                              ))}
                            </Select>
                          </Col>
                          <Col md={12} lg={6}>
                            <InputLabel>Degree *</InputLabel>
                            <Select
                              name='degree'
                              value={education[i].degree}
                              onChange={(e) => handleEducationInputs(e, i)}
                            >
                              <Option value='' disabled selected>
                                Click to Select
                              </Option>
                              {degreeOptions.map((x) => (
                                <Option value={x}>{x}</Option>
                              ))}
                            </Select>
                          </Col>
                          <Col md={12} lg={6}>
                            <InputLabel>Major *</InputLabel>
                            <Select
                              name='major'
                              value={education[i].major}
                              onChange={(e) => handleEducationInputs(e, i)}
                            >
                              <Option value='' disabled selected>
                                Click to Select
                              </Option>
                              {majorOptions.map((x) => (
                                <Option value={x}>{x}</Option>
                              ))}
                            </Select>
                          </Col>
                          <Col md={12} lg={6} className='horizontal-flex'>
                            <DatePickerWrapper>
                              <InputLabel>Graduation Date</InputLabel>
                              <DatePicker
                                format='MM/dd/yyyy'
                                value={education[i].graduationDate}
                                selected={education[i].graduationDate}
                                className='datepicker'
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode='select'
                                onChange={(date) =>
                                  setEducation((prev) => {
                                    const _ = prev
                                    _[i].graduationDate = date
                                    return [..._]
                                  })
                                }
                              />
                            </DatePickerWrapper>
                          </Col>
                          <Col md={12} lg={12}>
                            <Answer>
                              <Checkbox
                                type='checkbox'
                                id='degreeInProgress'
                                name='degreeInProgress'
                                value={education[i].typeOfDegree}
                                onChange={(e) => handleEducationInputs(e, i)}
                              />
                              <RadioLabel htmlFor='degreeInProgress'>
                                Degree in Progress
                              </RadioLabel>
                            </Answer>
                          </Col>
                          <Col md={12} lg={12}>
                            <DeleteInput
                              onClick={() =>
                                setEducation((prev) => {
                                  const array = [...prev]
                                  array.splice(i, 1)
                                  return [...array]
                                })
                              }
                            >
                              Delete Applicant Education
                            </DeleteInput>
                            <HorizontalDivider></HorizontalDivider>
                          </Col>
                        </>
                      ))}

                    <AddInput
                      onClick={() =>
                        setEducation((prev) => [
                          ...prev,
                          {
                            institution: '',
                            typeOfDegree: '',
                            degree: '',
                            major: '',
                            graduationDate: '',
                            degreeInProgress: false,
                          },
                        ])
                      }
                    >
                      Add Applicant Education
                    </AddInput>
                  </Row>

                  <Row className='section-row'>
                    <Title>Professional License</Title>
                    {license.length > 0 &&
                      license.map((x, i) => (
                        <>
                          <Col md={12} lg={6}>
                            <InputLabel>Professional License *</InputLabel>
                            <Input
                              name='professionalLicense'
                              value={license[i].professionalLicense}
                              onChange={(e) => handleLicenseInputs(e, i)}
                            />
                          </Col>
                          <Col md={12} lg={6}>
                            <InputLabel>Issuing State</InputLabel>
                            <Select
                              name='issuingState'
                              value={license[i].issuingState}
                              onChange={(e) => handleLicenseInputs(e, i)}
                            >
                              <Option value='' disabled selected>
                                Click to Select
                              </Option>
                              {issuingStateOptions.map((x) => (
                                <Option value={x}>{x}</Option>
                              ))}
                            </Select>
                          </Col>
                          <Col md={12} lg={6}>
                            <InputLabel>Other</InputLabel>
                            <Input
                              name='other'
                              value={license[i].other}
                              onChange={(e) => handleLicenseInputs(e, i)}
                            />
                          </Col>
                          <Col md={12} lg={12}>
                            <DeleteInput
                              onClick={() =>
                                setLicense((prev) => {
                                  const array = [...prev]
                                  array.splice(i, 1)
                                  return [...array]
                                })
                              }
                            >
                              Delete Professional License
                            </DeleteInput>
                            <HorizontalDivider></HorizontalDivider>
                          </Col>
                        </>
                      ))}

                    <AddInput
                      onClick={() =>
                        setLicense((prev) => [
                          ...prev,
                          {
                            professionalLicense: '',
                            issuingState: '',
                            other: '',
                          },
                        ])
                      }
                    >
                      Add Professional License
                    </AddInput>
                  </Row>

                  <Row className='section-row'>
                    <Title>Cover Letter</Title>
                    {!typeCover ? (
                      <Col sm={12} lg={12}>
                        <VerticalCol>
                          <Upload htmlFor='cover'>Upload Cover Letter</Upload>
                          <Input
                            className='hidden'
                            type='file'
                            id='cover'
                            onChange={handleCoverLetterUpload}
                          />
                          or
                          <Button onClick={() => setTypeCover(true)}>
                            Type it manually
                          </Button>
                        </VerticalCol>
                      </Col>
                    ) : (
                      <Col sm={12} lg={12}>
                        <TextArea
                          value={inputs.cover}
                          name='cover'
                          onChange={handleInputs}
                          margin
                        ></TextArea>
                        <Cancel onClick={() => setTypeCover(false)}>
                          Cancel Cover Letter
                        </Cancel>
                      </Col>
                    )}
                  </Row>

                  <Row className='section-row'>
                    <Title>Additional Document</Title>
                    <Col sm={12} lg={12}>
                      <VerticalCol>
                        <Upload htmlFor='additional'>Upload document</Upload>
                        <Input
                          className='hidden'
                          type='file'
                          id='additional'
                          onChange={handleAdditionalDocumentUpload}
                        />
                      </VerticalCol>
                    </Col>
                  </Row>

                  <Row className='section-row no-margin'>
                    <QA>
                      <Question noMargin>Referral Source: *</Question>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.referralSource === 'LinkedIn'}
                          id='LinkedIn'
                          value='LinkedIn'
                          name='referralSource'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='LinkedIn'>LinkedIn</RadioLabel>
                      </Answer>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.referralSource === 'Indeed'}
                          id='Indeed'
                          value='Indeed'
                          name='referralSource'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='Indeed'>Indeed</RadioLabel>
                      </Answer>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={
                            inputs.referralSource === 'Con-Real Career Site'
                          }
                          id='Con-Real Career Site'
                          value='Con-Real Career Site'
                          name='referralSource'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='Con-Real Career Site'>
                          Con-Real Career Site
                        </RadioLabel>
                      </Answer>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.referralSource === 'Facebook'}
                          id='Facebook'
                          value='Facebook'
                          name='referralSource'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='Facebook'>Facebook</RadioLabel>
                      </Answer>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={
                            inputs.referralSource === 'School/Collage Job Board'
                          }
                          id='School/Collage Job Board'
                          value='School/Collage Job Board'
                          name='referralSource'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='School/Collage Job Board'>
                          School/Collage Job Board
                        </RadioLabel>
                      </Answer>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.referralSource === 'Career Fair'}
                          id='Career Fair'
                          value='Career Fair'
                          name='referralSource'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='Career Fair'>
                          Career Fair
                        </RadioLabel>
                      </Answer>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={
                            inputs.referralSource === 'Employee Referral'
                          }
                          id='Employee Referral'
                          value='Employee Referral'
                          name='referralSource'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='Employee Referral'>
                          Employee Referral
                        </RadioLabel>
                      </Answer>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.referralSource === 'Walk-in'}
                          id='Walk-in'
                          value='Walk-in'
                          name='referralSource'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='Walk-in'>Walk-in</RadioLabel>
                      </Answer>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.referralSource === 'Agency'}
                          id='Agency'
                          value='Agency'
                          name='referralSource'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='Agency'>Agency</RadioLabel>
                      </Answer>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.referralSource === 'Client Referral'}
                          id='Client Referral'
                          value='Client Referral'
                          name='referralSource'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='Client Referral'>
                          Client Referral
                        </RadioLabel>
                      </Answer>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.referralSource === 'Word-of-Mouth'}
                          id='Word-of-Mouth'
                          value='Word-of-Mouth'
                          name='referralSource'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='Word-of-Mouth'>
                          Word-of-Mouth
                        </RadioLabel>
                      </Answer>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.referralSource === 'Other'}
                          id='Other'
                          value='Other'
                          name='referralSource'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='Other'>Other</RadioLabel>
                      </Answer>
                    </QA>
                    {inputs.referralSource === 'Other' && (
                      <QA>
                        <Question>
                          Please identify "other" referral resource: *
                        </Question>
                        <Col md={12} lg={6}>
                          <Input
                            name='otherReferralSource'
                            value={inputs.otherReferralSource}
                            onChange={handleInputs}
                          />
                        </Col>
                      </QA>
                    )}
                    <QA>
                      <Question>
                        What is the position you’re applying for? *
                      </Question>
                      <Input
                        name='position'
                        value={inputs.position}
                        onChange={handleInputs}
                      ></Input>
                    </QA>
                    <QA>
                      <Question>What is your salary expectation?</Question>
                      <TextArea
                        name='salaryExpectation'
                        value={inputs.salaryExpectation}
                        onChange={handleInputs}
                      ></TextArea>
                    </QA>
                    <QA>
                      <Question>Are you willing to relocate? *</Question>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.relocate === 'Yes'}
                          id='Yes'
                          value='Yes'
                          name='relocate'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='LinkedIn'>Yes</RadioLabel>
                      </Answer>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.relocate === 'No'}
                          id='Indeed'
                          value='No'
                          name='relocate'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='Indeed'>No</RadioLabel>
                      </Answer>
                    </QA>
                    <QA>
                      <Question>
                        Are you legally authorized to work in the United States?
                        *
                      </Question>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.workInUS === 'Yes'}
                          id='Yes'
                          value='Yes'
                          name='workInUS'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='LinkedIn'>Yes</RadioLabel>
                      </Answer>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.workInUS === 'No'}
                          id='Indeed'
                          value='No'
                          name='workInUS'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='Indeed'>No</RadioLabel>
                      </Answer>
                    </QA>
                    <QA>
                      <Question>Have you been employed by Con-Real? *</Question>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.alreadyEmployed === 'Yes'}
                          id='Yes'
                          value='Yes'
                          name='alreadyEmployed'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='LinkedIn'>Yes</RadioLabel>
                      </Answer>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.alreadyEmployed === 'No'}
                          id='No'
                          value='No'
                          name='alreadyEmployed'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='Indeed'>No</RadioLabel>
                      </Answer>
                    </QA>
                    <QA>
                      <Question>
                        Will you now or in the future require sponsorship for
                        employment visa status (e.g. H-1B, TN, etc.)? *
                      </Question>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.sponsorship === 'Yes'}
                          id='Yes'
                          value='Yes'
                          name='sponsorship'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='LinkedIn'>Yes</RadioLabel>
                      </Answer>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.sponsorship === 'No'}
                          id='Indeed'
                          value='No'
                          name='sponsorship'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='Indeed'>No</RadioLabel>
                      </Answer>
                    </QA>
                    <QA>
                      <Question>
                        Have you ever pled “guilty” or “no contest” to, or been
                        convicted of a crime? *
                      </Question>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.crime === 'Yes'}
                          id='Yes'
                          value='Yes'
                          name='crime'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='LinkedIn'>Yes</RadioLabel>
                      </Answer>
                      <Answer>
                        <Radio
                          type='radio'
                          checked={inputs.crime === 'No'}
                          id='Indeed'
                          value='No'
                          name='crime'
                          onChange={(e) => handleInputs(e)}
                        />
                        <RadioLabel htmlFor='Indeed'>No</RadioLabel>
                      </Answer>
                    </QA>
                    {inputs.crime === 'Yes' && (
                      <QA>
                        <Question>Please provide date(s) and details:</Question>
                        <TextArea
                          name='crimeDetails'
                          value={inputs.crimeDetails}
                          onChange={handleInputs}
                        ></TextArea>
                      </QA>
                    )}
                  </Row>
                </>
              ) : (
                <>
                  <Row className='section-row'>
                    <Title>Acknowledgement</Title>
                    <Text>
                      I understand that misrepresentation or omission of facts
                      called for is cause of unfavorable consideration of my
                      application or dismissal from Con-Real's employ. This
                      employment application is not a contract at this time or
                      in the future. If I am employed by Con-Real, I agree to
                      accept and confirm to its rules and regulations. I
                      understand that my employment would be "at-will" and that
                      my employment could be terminated by either party, with or
                      without cause and with or without notice.
                    </Text>
                    <Answer>
                      <Checkbox
                        type='checkbox'
                        value={isAgreed}
                        checked={isAgreed}
                        onChange={(e) => setIsAgreed(e.target.checked)}
                      />
                      <RadioLabel htmlFor='agree'>I agree</RadioLabel>
                    </Answer>
                  </Row>
                  <Row className='section-row no-margin'>
                    <Title>Submit Application</Title>
                    <Text>
                      To submit your finalized application, please click the
                      "Submit" button below.
                    </Text>
                  </Row>
                </>
              )}
            </Overlay>
            <Buttons>
              {currentStep === 2 && (
                <ButtonNav
                  back
                  onClick={() => setCurrentStep((prev) => prev - 1)}
                >
                  Back
                </ButtonNav>
              )}
              {currentStep === 1 ? (
                <ButtonNav onClick={() => nextStep()}>Next</ButtonNav>
              ) : (
                <ButtonNav onClick={handleSubmit}>Submit</ButtonNav>
              )}
            </Buttons>
          </>
        )}
      </Wrapper>
    </Container>
  )
}

export default Home
